import { CompactUser } from "../../../../core/CompactModels"


export default interface UsersAddonModel {
    id?: string
    userId?: string
    user?: CompactUser

    addonType?: AddonTypes

    count?: number
    nextPeriodCount?: number

    active?: boolean
    canceled?: boolean
    expired?: boolean

    createdAt?: Date
    renewedAt?: Date
    expiresAt?: Date
}

export enum AddonTypes {
    None = 0,
    ExtraSeat = 1,
    WhatsApp = 2,
    Telegram = 3
}